export const GrassList = [
	{
		title: "Feb Co-Ed Quads",
		type: "Quads",
		teams: "4 players - 2 girls minimum",
		group: "Competitive and Recreational Divisions",
		when: "February 28th",
		date: new Date("2/28/2026"),
		where: "Palo Verde High School",
		registerurl: "https://volleyballlife.com/event/35696",
		visible: true,
	},
	{
		title: "Jan Co-Ed Quads",
		type: "Quads",
		teams: "4 players - 2 girls minimum",
		group: "Competitive and Recreational Divisions",
		when: "January 24th",
		date: new Date("1/24/2026"),
		where: "Palo Verde High School",
		registerurl: "https://volleyballlife.com/event/34606",
		visible: true,
		past: true,
	},
	{
		title: "AZ Grass Championships",
		type: "Triples",
		teams: "3 girls or 3 guys",
		group: "Open and Rec Divisions",
		when: "December 26th + 27th",
		date: new Date("12/26/2025"),
		where: "University of Arizona",
		registerurl: "https://volleyballlife.com/event/33006",
		visible: true,
		past: true,
	},
	{
		title: "Nov Triples",
		teams: "3 girls or 3 guys",
		group: "Open and Rec Divisions",
		when: "Sunday, November 16th",
		date: new Date("11/16/2025"),
		where: "Palo Verde High School",
		registerurl: "https://volleyballlife.com/event/33015?tab=information",
		visible: true,
		past: true,
	},
	{
		title: "Oct Quads",
		teams: "2 girls, 2 guys",
		group: "Open and Rec Divisions",
		when: "Sunday, October 5th",
		date: new Date("10/5/2025"),
		where: "Palo Verde High School",
		resultsurl:
			"https://docs.google.com/spreadsheets/d/1uV01TbjZx490QpNIWRTcDAQCVGusyiFEnbWcnmP23T8/edit?usp=sharing",
		visible: true,
		past: true,
	},
	{
		title: "Jul Quads",
		teams: "2 girls, 2 guys",
		group: "Adults and Juniors",
		when: "Saturday, July 12th",
		date: new Date("7/12/2025"),
		where: "Dan Felix Memorial Park",
		visible: true,
		resultsurl:
			"https://docs.google.com/spreadsheets/d/1PhHKUqJnuZhWHfnApivz2R51Vu3sDOykcZ0aSyQV3HU/edit?usp=sharing",
		past: true,
	},
	{
		title: "Jun Quads",
		teams: "2 girls, 2 guys",
		group: "Adults and Juniors",
		when: "Sunday, June 1st",
		date: new Date("6/1/2025"),
		where: "Dan Felix Memorial Park",
		resultsurl:
			"https://docs.google.com/spreadsheets/d/1U_0aCLKwTCA677ticnvqvtu4p6yRUfoy0IgjYDRg7Yk",

		visible: true,
		past: true,
	},
	{
		title: "Feb Quads",
		teams: "2 girls, 2 guys",
		group: "Adults and Juniors",
		when: "Saturday, February 8th",
		date: new Date("2/8/2025"),
		where: "Rillito Regional Park",
		registerurl:
			"https://docs.google.com/forms/d/e/1FAIpQLScV2pvNDI7CgHJJ-P7eiPNn98QXkNWW3oyVWI2J4dngK-CKfw/viewform?usp=header",
		resultsurl:
			"https://docs.google.com/spreadsheets/d/1-zMwt287I6iMWVcwdlzIyIE2CZXSc4a_KgiP65qAl3Q/edit?usp=sharing",
		visible: true,
		past: true,
	},
];
